import React, { Component } from 'react';
import { Panel, PopDeleteConfirm } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { Table, Icon, Checkbox, Button } from 'antd';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Enums from 'utils/EnumsManager';
import { toTimezone } from 'utils/dateTimeUtils';
import PropTypes from 'prop-types';
import { fetchWorkflows, updateWorkflowStatus, deleteWorkflow } from '../flow/action';

const { PhantomId } = Enums;

const propTypes = {
  workflows: PropTypes.array.isRequired,
  workflowTablePagination: PropTypes.object.isRequired,
  fetchWorkflows: PropTypes.func.isRequired,
  updateWorkflowStatus: PropTypes.func.isRequired,
  deleteWorkflow: PropTypes.func.isRequired,
};

class WorkflowPanel extends Component {
  componentDidMount() {
    const { workflowTablePagination, fetchWorkflows } = this.props;
    const { perPage, currentPage } = workflowTablePagination;
    fetchWorkflows(perPage, currentPage);
  }

  handleStatusChange(e, id) {
    const isChecked = e.target.checked;
    this.props.updateWorkflowStatus(id, isChecked);
  }

  handelDeleteWorkflow(id) {
    const { deleteWorkflow, fetchWorkflows, workflowTablePagination } = this.props;
    deleteWorkflow(id, () => {
      const { perPage, currentPage } = workflowTablePagination;
      fetchWorkflows(perPage, currentPage);
    });
  }

  render() {
    const { workflows, workflowTablePagination, fetchWorkflows } = this.props;

    const rightActions = (
      <Link to={`/setup/settings/workflow?id=${PhantomId}`}>
        <Button
          key="addBtn"
          className="btn-ellipse ml-sm"
          size="small"
          icon="plus"
        >
          <FormattedMessage id="page.WorkflowList.createNew" />
        </Button>
      </Link>
    );

    const columns = [{
      title: <FormattedMessage id="page.WorkflowList.action" />,
      key: 'id',
      render: record => (
        <PopDeleteConfirm
          placement="right"
          onConfirm={() => this.handelDeleteWorkflow(record.id)}
        >
          <Icon
            type="delete"
            className="pl-sm cursor-pointer"
          />
        </PopDeleteConfirm>
      )
    }, {
      title: <FormattedMessage id="page.WorkflowList.status" />,
      render: record => (
        <Checkbox
          checked={record.is_active}
          onChange={e => this.handleStatusChange(e, record.id)}
        />
      )
    }, {
      title: <FormattedMessage id="page.WorkflowList.workflowCode" />,
      key: 'rule_code',
      dataIndex: 'rule_code',
    }, {
      title: <FormattedMessage id="page.WorkflowList.workflowName" />,
      key: 'name',
      render: record => (
        <Link
          to={`/setup/settings/workflow?id=${record.id}`}
          className="account-theme-text"
        >
          {record.name}
        </Link>
      )
    }, {
      title: <FormattedMessage id="page.WorkflowList.createdBy" />,
      key: 'created_by_user.name',
      dataIndex: 'created_by_user.name',
    }, {
      title: <FormattedMessage id="page.WorkflowList.createdDate" />,
      dataIndex: 'created_at',
      render: text => toTimezone(text, true),
    }, {
      title: <FormattedMessage id="page.WorkflowList.triggerType" />,
      dataIndex: 'op_code',
    }, {
      title: <FormattedMessage id="page.WorkflowList.description" />,
      dataIndex: 'description',
    }];

    const pagination = {
      defaultCurrent: workflowTablePagination.currentPage,
      current: workflowTablePagination.currentPage,
      defaultPageSize: workflowTablePagination.perPage,
      pageSize: workflowTablePagination.perPage,
      total: workflowTablePagination.total,
      size: 'small',
      onChange(page, pageSize) {
        fetchWorkflows(pageSize, page);
      },
    };

    return (
      <Panel
        panelTitle={<FormattedMessage id="page.WorkflowList.workflow" />}
        actionsRight={rightActions}
        contentClasses="pt-lg pb-lg pl-lg pr-lg"
      >
        <Table
          dataSource={workflows}
          columns={columns}
          pagination={pagination}
          rowKey="id"
        />
      </Panel>
    );
  }
}

const mapStateToProps = ({ setup, global }) => {
  const { workflows, workflowTablePagination } = setup.workFlow.workflowList;
  return {
    lang: global.language,
    workflows,
    workflowTablePagination,
  };
};

const mapDispatchToProps = {
  fetchWorkflows,
  updateWorkflowStatus,
  deleteWorkflow,
};

WorkflowPanel.propTypes = propTypes;

export default connect(mapStateToProps, mapDispatchToProps)(WorkflowPanel);



// WEBPACK FOOTER //
// ./src/views/Setup/WorkflowList/component/workflowPanel.js